import React from 'react'
import { bool } from 'prop-types'
import { Color, Icon } from '@cobalt/cobalt-react-components'
import { SECURITY_KEY_ANIMATION } from '../../constants/images'
import { MFA_WEB_AUTHN_NAME } from '../../constants/ui.labels'
import '../../../assets/setup-webauthn-animation.css'

const SetupMFAWebAuthnRegisterAnimation = ({ isValid }) => (
  <div className={`svg-animation ${isValid ? 'ok' : ''}`}>
    <div className="co--push-right">
      {/* using an object to force rendering the svg animation, which doesn't reset when re-rendered */}
      <object type="image/svg+xml" data={SECURITY_KEY_ANIMATION} aria-label="">
        {MFA_WEB_AUTHN_NAME}
      </object>
    </div>
    <div className="svg-success co--push-center">
      <Icon name={Icon.CHECK} xlarge color={Color.green[600]} />
    </div>
  </div>
)

SetupMFAWebAuthnRegisterAnimation.defaultProps = {
  isValid: false
}

SetupMFAWebAuthnRegisterAnimation.propTypes = {
  isValid: bool
}

export default SetupMFAWebAuthnRegisterAnimation
